/* Version: 3.5.137 */
'use client';
var typography = {
  fontFamily: '"Manulife JH Sans", "Helvetica", "Arial", sans-serif',
  fontFamilySerif: '"Manulife JH Serif", serif',
  fontWeightLight: '300',
  fontWeightNormal: '400',
  fontWeightDemibold: '600',
  fontWeightBold: '700',
  fontStretch: 'normal',
  fontStyle: 'normal',
  fontStyleItalic: 'italic',
  letterSpacing: 'normal',
  lineHeight: '1.5rem',
  fontSize: '1rem',
  fontSizeSmall: '0.875rem',
  fontWeight: 'normal'
};

export { typography as default, typography };
